import { changeUsersStatusAPI, createRoleIdentityMappingAPI, createUserAPI, createUserApplicationMappingAPI, deleteRoleUserMappingAPI, deleteUserApplicationMappingAPI, getUserApplicationMappingPagingAPI, getUserPagingAPI, updateUsersAPI, userGet, userGetByIdAPI, userNotInApplicationAPI, userNotInRolesAPI, userRoleMappingPagingAPI } from "../../../api/url"
import { createAPI, deleteAPI, getByBodyAPI, getByIdAPI, updateAPI } from "../../../redux/crudSlice"
import { AppDispatch, store } from "../../../store/store"
import { APICallFunction } from "../role/apiCall"
import { UserKeys } from "./entity"

const { dispatch } = store


export const getUserPagingData = async (dispatch: AppDispatch, _request: any) => {
  const res = await dispatch(getByBodyAPI({
    key: UserKeys.paging,
    url: getUserPagingAPI,
    request: _request,
  }));
  return res?.payload?.value;
}

export const getUserRoleMapping = async (dispatch: AppDispatch, _request: any) => {
  const res = await dispatch(getByBodyAPI({
    key: UserKeys.getRoleMapping,
    url: userRoleMappingPagingAPI,
    request: _request,
  }));
  return res?.payload?.value;
}


export const deleteUser = async (dispatch: AppDispatch, _request: Object) => {
  const res = await dispatch(
    deleteAPI({
      key: UserKeys.delete,
      url: changeUsersStatusAPI(_request),
      request: { IsActive: false, IsDeleted: true }
    })
  );
  return res?.payload?.value;
};

export const getUserbyId: APICallFunction = async (params) => {
  const { key = UserKeys.get, request = {}, url = userGetByIdAPI(request?.id) } = params;
  const res = await dispatch(getByIdAPI({ key: key, url: url }));
  return { ...res?.payload?.value, data: { ...res?.payload?.value?.data?.Persons, ...res?.payload?.value?.data } };
}

export const createUser: APICallFunction = async (params) => {
  const { key = UserKeys.create, request = {}, url = createUserAPI } = params;
  const res = await dispatch(createAPI({ key: key, url: url, request: request }));
  return res?.payload?.value;
}
export const updateUser: APICallFunction = async (params) => {
  const { key = UserKeys.update, request = {}, url = updateUsersAPI(request.id) } = params;
  const res = await dispatch(updateAPI({ key: key, url: url, request: request }));
  return res?.payload?.value;
}
export const userNotInRoles: APICallFunction = async (params) => {
  const { key = UserKeys.notInRoles, request = {}, url = userNotInRolesAPI } = params;
  const res = await dispatch(getByBodyAPI({ key: key, url: url, request: request }));
  return res?.payload?.value;
}
export const userNotInApplication: APICallFunction = async (params) => {
  const { key = UserKeys.notInApplications, request = {}, url = userNotInApplicationAPI } = params;
  const res = await dispatch(getByBodyAPI({ key: key, url: url, request: request }));
  return res?.payload?.value;
}
export const addUserRoleMapping: APICallFunction = async (params) => {
  const { key = UserKeys.addRoleMapping, request = {}, url = createRoleIdentityMappingAPI } = params;
  const res = await dispatch(createAPI({ key: key, url: url, request: request }));
  return res?.payload?.value;
}
export const addUserApplicationMapping: APICallFunction = async (params) => {
  const { key = UserKeys.addApplicationMapping, request = {}, url = createUserApplicationMappingAPI } = params;
  const res = await dispatch(createAPI({ key: key, url: url, request: request }));
  return res?.payload?.value;
}


export const getUserApplicationMapping = async (dispatch: AppDispatch, _request: Object) => {
  const res = await dispatch(getByBodyAPI({
    key: UserKeys.getApplicationMapping,
    url: getUserApplicationMappingPagingAPI,
    request: { ..._request },
  }))

  return res?.payload?.value;
}


export const deleteUserApplicationMapping = async (dispatch: AppDispatch, _request: Object) => {
  const res = await dispatch(
    deleteAPI({
      key: UserKeys.deleteApplicationMapping,
      url: deleteUserApplicationMappingAPI,
      request: [_request]
    })
  );

  return res?.payload?.value;
};
export const deleteUserRoleMapping = async (dispatch: AppDispatch, _request: Object) => {
  const res = await dispatch(
    deleteAPI({
      key: UserKeys.deleteRoleMapping,
      url: deleteRoleUserMappingAPI,
      request: [_request]
    })
  );

  return res?.payload?.value;
};